import { SessionAdapter, Storage } from '@mirai/data-sources';
import mixpanel from 'mixpanel-browser';

import { EXPERIMENT_ID, VARIANT, VARIANT_STORAGE_KEY } from '../../../Core.constants';

export const trackExperiment = (props = {}, { register } = {}) => {
  const variant = props[EXPERIMENT_ID];
  if (!EXPERIMENT_ID || !Object.values(VARIANT).includes(variant)) return;

  register(props);

  const storage = new Storage({ adapter: SessionAdapter });
  const key = `${VARIANT_STORAGE_KEY}:exposure`;
  if (storage.get(key) === variant) return;

  mixpanel.track('$experiment_started', {
    ...props,
    'Experiment name': EXPERIMENT_ID,
    'Variant name': variant,
  });
  storage.set(key, variant);
};
